import axios from "axios";
import { convertArgMapListToQueryString, getCookie } from "../../utils";
import { API_BASE_PATH } from "../../const";

const getExportFields = (args) => {
    return axios
        .get(API_BASE_PATH + `export_columns/?type=` + args.type, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getExportPreview = (args) => {
    let filters = convertArgMapListToQueryString(args.filters)
    return axios
        .get(API_BASE_PATH + `exports/preview/${filters}type=${args.type}&fields=${args.fields.map((x) => x.value).join(",")}`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const createExport = (args) => {
    return axios
        .post(API_BASE_PATH + `exports/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};

const getExports = (args) => {
    
    return axios
        .get(API_BASE_PATH + `exports/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getExportDetails = (args) => {
    
    return axios
        .get(API_BASE_PATH + `exports/${args.exportId}/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getExportInfo = (args) => {
    return axios
        .get(API_BASE_PATH + `exports/get_export_info/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const updateExport = (args) => {
    return axios
        .patch(API_BASE_PATH + `exports/${args.exportId}/`, {
            ...args.data
        }, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const duplicateExport = (args) => {
    return axios
        .post(API_BASE_PATH + `exports/${args.exportId}/duplicate/`, {
            ...args.data
        }, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};


const ExportService = {
    getExportFields,
    getExportPreview,
    createExport,
    getExports,
    getExportDetails,
    getExportInfo,
    updateExport,
    duplicateExport,
};

export default ExportService;